export default "__VITE_ASSET__BuSDAecd__"